import langConf from 'src/translations/langConf';
export const getLanguageByISO6392 = (iso) => {
    return langConf.allowedLanguages.find((l) => l.iso6392 === iso);
};
export const getLanguageByAppFormat = (val) => {
    return langConf.allowedLanguages.find((l) => l.appFormat === val);
};
